import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { EntityrecordApi } from '../../sdk/services/custom';
import * as _ from 'lodash';
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';

@Component({
    selector: 'formly-cascaded-lookup',
    template: `
	<a *ngIf="required"><font color="red"> *</font></a>
	<input [type]="type" [formControl]="formControl" class="form-control" 
      [formlyAttributes]="field" [ngClass]="{'form-control-danger': valid}" readonly>
  `,
    providers: [EntityrecordApi]
})


export class CascadedLookup extends FieldType implements OnInit, OnDestroy {

    private formulae = [];
    private modelValues = [];
    private currentuser;
    private appId;

    get type() {
        return this.to.type || 'text';
    }

    get readonly() {
        return this.to.readonly || false;
    }

    get required() {
        return this.to.required || false;
    }

    get icon() {
        return this.to.icon || null;
    }

    private parentRecordId: any = '';
    constructor(private _LoopBackAuth: LoopBackAuth,
        private _PlatformApp: PlatformApp,
        private _EntityrecordApi: EntityrecordApi) {
        super();
    }

    ngOnInit() {
        if (!this.form['subscriptions']) {
            this.form['subscriptions'] = [];
        }
        if (!this.form['newcontrols']) {
            this.form['newcontrols'] = {};
        }
        for (let key in this.form.controls) {
            this.form['newcontrols'][key] = this.form.controls[key];
        }
        if (this.field['formulae']) {
            this.formulae = this.field['formulae'];
            if (this.field.formControl) {
                this.addWatcher(this.field.formControl);
            }
        }

        if (this.field.defaultValue && !this.model[this.key]) {
            this.formControl.setValue(this.field.defaultValue);
        }

        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        if (PlatformApp.getAppVariable('platformApp')) {
            this.appId = PlatformApp.getAppVariable('referenceAppId');
        } else {
            this.appId = this.currentuser.appId;
        }

        if (this.field['parentRecordId'] && this.field['parentRecordField']) {
            this.form['subscriptions'].push(this.form.controls[this.field['parentRecordId']]
                .valueChanges
                .subscribe((parentRecordId: any) => {
                    if (parentRecordId) {
                        this._EntityrecordApi.findById(parentRecordId)
                            .subscribe((record) => {
                                if (record && record['data'] && record['data'][this.field['parentRecordField']]) {
                                    this.formControl.setValue(record['data'][this.field['parentRecordField']]);
                                }
                            });
                    }
                }));
        }
    }

    private addWatcher(formControl) {
        this.form['subscriptions'].push(formControl.valueChanges.subscribe((updatedValue: any) => {
            for (let i = 0; i < this.formulae.length; i++) {
                let formula = this.formulae[i];
                if (this.setModelValues(formula['fields'], updatedValue)) {
                    this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
                }
            }
        }));
    }

    private setModelValues(fieldArray, updatedValue) {
        let requiredFieldsExist = true;
        this.modelValues = [];
        for (let j = 0; j < fieldArray.length; j++) {
            if (!this.model[fieldArray[j]]) {
                requiredFieldsExist = false;
                break;
            } else {
                if (fieldArray[j] === this.field.key) {
                    this.modelValues.push(updatedValue);
                } else {
                    this.modelValues.push(this.model[fieldArray[j]]);
                }
            }
        }
        return requiredFieldsExist;
    }

    private setResults(resultArray, value): void {
        for (let i = 0; i < resultArray.length; i++) {
            let resultField = resultArray[i];
            if (this.form.controls[resultField]) {
                this.form.controls[resultField].setValue(value);

                if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
                    this.form.setControl(resultField, this.form['newcontrols'][resultField]);
                    this.form.controls[resultField].setValue(value);
                }
            } else {
                if (this.form['newcontrols'][resultField]) {
                    this.form.addControl(resultField, this.form['newcontrols'][resultField]);
                    this.form.controls[resultField].setValue(value);
                } else {
                    this.model[resultField] = value;
                }
            }
        }
    }

    ngOnDestroy(): void {
        for (let i = 0; i < this.form['subscriptions'].length; i++) { this.form['subscriptions'][i].unsubscribe(); }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/fields/cascadedlookup.ts